import { LocalizationService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { take } from 'rxjs';
import { CallLanguageCodeDto } from 'src/core/models/call/call-language-code.dto';
import { LLMConfigurationDto } from 'src/core/models/llm/llm-configuration.dto';
import { Operators } from 'src/core/models/request/operator.enum';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { CrudService } from 'src/core/services/crud/crud.service';

@Component({
  selector: 'ca-ai-category-discovery-settings',
  templateUrl: './ai-category-discovery-settings.component.html',
  styleUrls: ['./ai-category-discovery-settings.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  standalone: false,
})
export class AiCategoryDiscoverySettingsComponent implements OnInit {
  llmConfigurations: LLMConfigurationDto[] = [];
  currentLanguageName: string = '';

  private languages: CallLanguageCodeDto[] = [];

  get form(): FormGroup {
    return this.formGroupDirective.form;
  }

  constructor(
    private formGroupDirective: FormGroupDirective,
    private crudService: CrudService,
    private settingService: ConfigurationSettingsService,
    private operators: Operators,
    private localizationService: LocalizationService,
  ) {}

  ngOnInit(): void {
    this.crudService
      .get<LLMConfigurationDto>(LLMConfigurationDto, {
        filters: [],
        sorters: [],
        skipCount: 0,
        maxResultCount: 9999,
      })
      .subscribe(response => {
        this.llmConfigurations = response.items;
      });

    this.settingService
      .getLanguageCodeList({
        filters: [
          { field: 'isVisible', operator: this.operators.Contains, value: true },
          { field: 'withoutMixed', operator: this.operators.Contains, value: true },
        ],
        sorters: [],
        maxResultCount: 99999,
        skipCount: 0,
      })
      .pipe(take(1))
      .subscribe(res => {
        this.languages = res.items;
        this.updateLanguageName();
      });

    this.form.get('languageCode')?.valueChanges.subscribe(val => {
      this.updateLanguageName();
    });

    this.form.get('automaticSummarizationDailyConversationLimit')?.valueChanges.subscribe(val => {
      if (val !== 0) {
        this.form.get('aiCategoryDiscoveryEnabled')?.setValue(false);
        this.form.get('aiCategoryDiscoveryEnabled')?.disable();
      } else {
        this.form.get('aiCategoryDiscoveryEnabled')?.enable();
      }
    });

    this.form.get('aiCategoryDiscoveryEnabled')?.valueChanges.subscribe(val => {
      if (val) {
        this.form.get('aiCategoryDiscoveryLlmConfigurationId')?.setValidators(Validators.required);
      } else {
        this.form.get('aiCategoryDiscoveryLlmConfigurationId')?.clearValidators();
        this.form.get('aiCategoryDiscoveryLlmConfigurationId')?.updateValueAndValidity();
      }
    });
  }

  private updateLanguageName(): void {
    const languageCode = this.form.get('languageCode')?.value;
    if (languageCode && this.languages.length > 0) {
      const language = this.languages.find(l => l.code === languageCode);
      if (language) {
        this.currentLanguageName = this.localizationService.instant(
          'Settings::Call.Language.' + language.name,
        );
      }
    }
  }
}
